import { ProviderAccount } from '@prisma/client'
import { message } from 'antd'
import { Api } from '~/core/trpc'
import { Oauth2Popup } from '~/plugins/data-connector/activepieces/helpers/oauth2Popup'

export const useAuthentication = () => {
  const ensureAccount = Api.ayrshare.ensureAccount.useMutation()

  const reconcileAccount = Api.ayrshare.reconcileAccount.useMutation()

  const generateAuthUrl = Api.ayrshare.generateAuthUrl.useMutation()

  const start = async (options: {
    organizationId: string
    providerAccount?: ProviderAccount
  }) => {
    try {
      const { providerAccount, organizationId } = options

      let providerAccountSelected = providerAccount

      if (!providerAccountSelected) {
        providerAccountSelected = await ensureAccount.mutateAsync({
          organizationId,
        })
      }

      const profileKey = providerAccountSelected.connection['profileKey']

      const { url } = await generateAuthUrl.mutateAsync({
        profileKey,
      })

      return { url, providerAccountId: providerAccountSelected.id }
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)
    }
  }

  const reconcile = async (options: {
    providerAccountId: string
    organizationId?: string
  }) => {
    try {
      await reconcileAccount.mutateAsync({
        providerAccountId: options.providerAccountId,
        organizationId: options.organizationId,
      })
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)
    }
  }

  return {
    start,
    reconcile,
    cancel: Oauth2Popup.close,
  }
}
